/**
 * Cursor pagination. `ARCHITECTURE.md` §API conventions: "Lists are cursor-paginated
 * (`?cursor=&limit=`), never offset, ordered by `(created_at, id)` unless the list names
 * another sort; the cursor then carries that sort's key and the tie-breaker, and is
 * refused under any other sort."
 *
 * `limit` coerces, so the one schema validates an HTTP query string (`?limit=50`)
 * and an MCP tool input (`{"limit": 50}`) without a second definition.
 */
import { z } from 'zod';
export const DEFAULT_PAGE_LIMIT = 25;
export const MAX_PAGE_LIMIT = 100;
export const CursorPageQuerySchema = z
    .object({
    cursor: z
        .string()
        .min(1)
        .max(500)
        .optional()
        .describe('The next_cursor from the previous page. Leave it out for the first page. Opaque — ' +
        'do not build one by hand.'),
    limit: z.coerce
        .number()
        .int()
        .min(1)
        .max(MAX_PAGE_LIMIT)
        .default(DEFAULT_PAGE_LIMIT)
        .describe(`How many items to return, 1 to ${String(MAX_PAGE_LIMIT)}. Defaults to ` +
        `${String(DEFAULT_PAGE_LIMIT)}.`),
})
    .describe('Cursor pagination for a list.');
/** One page of `item`. `next_cursor` is null on the last page. */
export function CursorPageSchema(item) {
    return z
        .object({
        items: z.array(item).describe('This page of items, ordered by (created_at, id).'),
        next_cursor: z
            .string()
            .nullable()
            .describe('Pass this back as `cursor` for the next page. Null when this is the last one.'),
    })
        .describe('One page of a cursor-paginated list.');
}
//# sourceMappingURL=pagination.js.map